export default "__VITE_ASSET__DME4G3XG__"